export default __webpack_public_path__ + "static/media/eQ.2ccaa947.jfif";